import { useMemo, useRef } from "react";
import SwiperGameList from "../SwiperGameList/SwiperGameList";
import { useLocation, useParams } from "react-router";
import React from "react";
import useDeviceType from "../../hook/useDeviceType";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import LoadingLine from "../Loading/LoadingLine";
import LoadingImage from "../Loading/LoadingImage";
import { useSelector } from "react-redux";
import ObserveInView from "../../utils/observeInView";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";
import {
  Box,
  Flex,
  Heading,
  Icon,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import TitleIcon from "../GameComponents/PlatformSelector/components/titleIcon";
import { menuIcon } from "../Menu/helper/menuIcon";
import { routeMappingV4 } from "../GameComponents/GameTypeSelector/utils/routeMapping_v4";

const GameCatalog = ({
  mainTitle,
  itemClass, //遊戲item class
  swiperProps,
  swiperClassName,
  closeComponent, //關閉組件
  wrapperClassName, //外層class
  hiddenHeader, //隱藏header
  dontTranslateMainTitle, //不翻譯mainTitle
  listType = "game", //game,promotion,sponsor
  list = [], // 列表
  observeFalse,
  hiddenButtonNavigator, //隱藏All ... 按鈕
  forceShow, //強制顯示維護的遊戲
  customGameList, //自定義遊戲列表
  fullImageLayout, // 全圖版型
  isHot,
  customFixedWidth,
  customHeight,
  hideGameName,
}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const splideRef = useRef();

  const titleColor = useColorModeValue("dark.100", "light.100");

  const gameConfig = useSelector((state) => state.isGameConfig);
  const { game_type, game_platform } = gameConfig || {};

  const { link: gameTypeLink } = routeMappingV4(game_type);

  const isMobile = useDeviceType() === "Mobile";

  const handleSlideRight = () => {
    if (splideRef.current) {
      const splide = splideRef.current.splide;
      const currentIndex = splide.index;
      const newIndex = currentIndex + 3;

      splide.go(newIndex);
    }
  };
  const handleSlideLeft = () => {
    if (splideRef.current) {
      const splide = splideRef.current.splide;
      const currentIndex = splide.index;
      const newIndex = currentIndex - 3;

      splide.go(newIndex);
    }
  };

  const listSize = useMemo(() => {
    return isMobile ? list?.slice(0, 15) : list?.slice(0, 30);
  }, [isMobile, list]);

  return (
    <ObserveInView
      props={{
        itemClass: itemClass,
        swiperProps: swiperProps,
        swiperClassName: swiperClassName,
      }}
      observeFalse={observeFalse}
    >
      <Box
        position={"relative"}
        borderRadius={"30px"}
        px={"15px !important"}
        py={{
          base: "10px",
          sm: "20px",
        }}
        pt={{
          base: "10px",
          sm: "20px",
        }}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="100%100%"
        className={`${closeComponent} ${wrapperClassName}`}
      >
        <Box position={`relative`} zIndex={`10`}>
          {hiddenHeader || (
            <Flex justifyContent={`space-between`} mb="10px">
              <Flex alignItems={`center`}>
                <LoadingLine className={`min-w-[130px] h-[20px] rounded-full`}>
                  <Flex
                    sx={{
                      "& > h3": {
                        // 應用到所有子Text元素
                        background:
                          "linear-gradient(180deg, rgba(2, 0, 36, 1) 0%, rgb(207 100 255) 0%, rgb(255 255 255) 50%, rgb(228 184 255) 75%, rgb(210 156 237) 100%)",
                        WebkitBackgroundClip: "text",
                        backgroundClip: "text",
                        color: "transparent",
                        textShadow: "0px 0px 3px rgb(158 0 255 / 30%)",
                      },
                    }}
                    gap="5px"
                    alignItems={`center`}
                  >
                    <TitleIcon
                      icon={menuIcon(mainTitle || "AllGames", "icon")}
                    />
                    <Heading
                      as="h3"
                      color={titleColor}
                      fontSize={{
                        base: "24px",
                      }}
                      mb="0px"
                      fontWeight={`medium`}
                    >
                      {mainTitle && !dontTranslateMainTitle
                        ? i18n(mainTitle)
                        : mainTitle}
                    </Heading>
                  </Flex>
                </LoadingLine>
              </Flex>
              <Box h="40px" display="flex" alignItems={`flex-end`}>
                <Flex alignItems={`center`} gap="5px">
                  {listType === "game" && (
                    <>
                      {mainTitle && !hiddenButtonNavigator ? (
                        <Link
                          to={`${gameTypeLink}/category/${game_platform}/AllGames`}
                        >
                          <Flex
                            // bg={"brand.500"}
                            border="1px solid"
                            borderColor="special.gold"
                            color={"special.gold"}
                            cursor={`pointer`}
                            py="8px"
                            px="20px"
                            height="30px"
                            fontWeight={`medium`}
                            fontSize={`sm`}
                            alignItems={`center`}
                            borderRadius={`lg`}
                          >
                            <LoadingLine className={``}>
                              {i18n("all")}{" "}
                            </LoadingLine>
                          </Flex>
                        </Link>
                      ) : null}
                      <Box
                        display={{ md: "flex", base: "none" }}
                        alignItems={`center`}
                        justifyContent={`center`}
                        borderRadius={`lg`}
                        width={`30px`}
                        // bg={clickBg}
                        border="1px solid"
                        borderColor="special.gold"
                        color={"special.gold"}
                        cursor={`pointer`}
                        py="8px"
                        px="20px"
                        height="30px"
                        onClick={handleSlideLeft}
                      >
                        <Icon as={MdOutlineKeyboardArrowLeft} fontSize="lg" />
                      </Box>
                      <Box
                        onClick={handleSlideRight}
                        display={{ md: "flex", base: "none" }}
                        alignItems={`center`}
                        justifyContent={`center`}
                        borderRadius={`lg`}
                        width={`30px`}
                        // bg={clickBg}
                        border="1px solid"
                        borderColor="special.gold"
                        color={"special.gold"}
                        cursor={`pointer`}
                        py="8px"
                        px="20px"
                        height="30px"
                      >
                        <Icon as={MdOutlineKeyboardArrowRight} fontSize="lg" />
                      </Box>
                    </>
                  )}
                </Flex>
              </Box>
            </Flex>
          )}
          <SwiperGameList
            isHot={isHot}
            forceShow={forceShow}
            ref={splideRef}
            list={listSize}
            listType={listType}
            itemClass={itemClass}
            swiperProps={swiperProps}
            swiperClassName={swiperClassName}
            customGameList={customGameList}
            fullImageLayout={fullImageLayout}
            customFixedWidth={customFixedWidth}
            customHeight={customHeight}
            hideGameName={hideGameName}
          />
        </Box>
      </Box>
    </ObserveInView>
  );
};

export default React.memo(GameCatalog);
